import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'app-withdrawal-detail',
  templateUrl: './withdrawal-detail.component.html',
  styleUrls: ['./withdrawal-detail.component.scss'],
})
export class WithdrawalDetailComponent implements OnInit {

  @Input() data: { transaction: any };

  transaction: any;
  formattedDate: string;
  formattedTime: string;
  isSuccess: boolean;
  isPending: boolean;
  isFailed: boolean;
  isDeposit: boolean;
  statusLabel: string;
  title: string;
  // Same-day withdrawal fee deducted from this withdrawal's payout.
  withdrawalFee: number = 0;
  netAmount: string;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.transaction = this.data.transaction;
    this.formattedDate = moment(this.transaction.created_date, 'X').format('MMM DD, YYYY');
    this.formattedTime = moment(this.transaction.created_date, 'X').format('h:mm A');

    this.withdrawalFee = Number(this.transaction.withdrawalFee) || 0;
    if (this.withdrawalFee > 0) {
      this.netAmount = (Number(this.transaction.amount) - this.withdrawalFee).toFixed(2);
    }

    this.isDeposit = this.transaction.type === 'deposit';
    this.isFailed = this.transaction.type === 'withdraw' && this.transaction.status === 'failed';
    this.isPending = this.transaction.type === 'withdraw' && this.transaction.status === 'pending';
    this.isSuccess = !this.isFailed && !this.isPending;

    if (this.isFailed) {
      this.statusLabel = 'Failed';
      this.title = 'Withdrawal Failed';
    } else if (this.isPending) {
      this.statusLabel = 'Processing';
      this.title = 'Withdrawal Pending';
    } else if (this.isDeposit) {
      this.statusLabel = 'Deposited';
      this.title = 'Bonus Payment';
    } else {
      this.statusLabel = 'Completed';
      this.title = 'Withdrawal';
    }
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
